
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "FilterSelect",
  props: {
    modelValue: {
      type: [String, Number],
      required: true
    },
    options: {
      type: Array as PropType<{ value: string | number; label: string }[]>,
      required: true
    },
    id: {
      type: String,
      default: "filter"
    },
    label: {
      type: String,
      required: false
    }
  },
  emits: ["update:modelValue", "change"],
  setup(props, { emit }) {
    const onChange = (event: Event) => {
      const value = (event.target as HTMLSelectElement).value;
      emit("update:modelValue", value);
      emit("change", value);
    };

    return {
      onChange
    };
  }
});
